import { FaIcon } from '@fe-learner-common';
import { faInfoCircle } from '@fortawesome/pro-regular-svg-icons/faInfoCircle';
import { ReactNode } from 'react';

type ResourceActionsProps = {
  children: ReactNode;
  hasDescription: boolean;
  onDescriptionClick: (resourceId: string) => void;
  resourceId: string;
  descriptionAriaLabel: string;
};

export const ResourceActions = ({
  resourceId,
  hasDescription,
  onDescriptionClick,
  descriptionAriaLabel,
  children,
}: ResourceActionsProps) => (
  <div className="lf:relative lf:z-10 lf:-mr-1 lf:-mt-1 lf:flex lf:items-center lf:gap-x-2">
    {hasDescription && (
      <button
        type="button"
        className="lf:l-btn lf:l-btn-sm lf:l-btn-tertiary lf:l-icon-btn lf:hover:bg-neutral-50"
        onClick={() => {
          onDescriptionClick(resourceId);
        }}
        aria-label={descriptionAriaLabel}
      >
        <FaIcon width={16} height={16} icon={faInfoCircle} />
      </button>
    )}
    {children}
  </div>
);
